var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvents = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#events_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "#EAE3DA",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#05676A",
  d: "M20.282 6.571c.66 0 1.196.518 1.196 1.156v2.09c1.77.678 3.022 2.346 3.022 4.297v6.691c0 2.554-2.143 4.624-4.786 4.624h-6.928c-2.643 0-4.786-2.07-4.786-4.624v-6.69c0-1.952 1.253-3.62 3.023-4.299V7.727c0-.638.536-1.155 1.197-1.156.66 0 1.196.518 1.196 1.156v1.764h5.669V7.727c0-.638.536-1.155 1.197-1.156m-7.496 5.232c-1.321 0-2.393 1.035-2.393 2.311v6.691c0 1.277 1.072 2.312 2.393 2.312h6.928c1.321 0 2.393-1.035 2.393-2.312v-6.69c0-1.277-1.072-2.312-2.393-2.312zm5.985 1.582c.66 0 1.196.518 1.196 1.156s-.536 1.156-1.196 1.156h-5.543c-.66 0-1.196-.518-1.197-1.156 0-.638.536-1.156 1.197-1.156z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "events_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})))));
export default SvgEvents;